export default __webpack_public_path__ + "static/media/veditor-preview.668c7a59.png";